import { roundRect } from "../../../../utils/utils";
import { GRID_CONTENT_CONTAINER_SELECTED_STYLE, GRID_CONTENT_CONTAINER_STYLE } from "../cell/grid-cell.config";
import { FabricRectangular } from "../FabricRectangular";

/**
 * @description Plugin container used in gridCell
 */
export class PluginContainer extends FabricRectangular {
    state = {
        selected: false, dragHover: false, active: false, disabled: false, temporary: false, hover: false, drawed: false
    };

    layout = {
        x: null, y: null, width: null, height: null, radius: null, styles: {}
    };

    // Container geometrical points
    constructor(layout, state, canvas) {
        super(layout);
        this.layout = { ...this.layout, ...layout };
        this.state = { ...this.state, ...state };
        this.ctx = canvas;
        this.setPoints();
    }

    // draws the container
    draw() {
        // Check to see if it was initially drawed, clear it and then proceed with a new drawing.
        if (this.state.drawed) {
            this.clearCell();
        }
        this.state.drawed = true;
        const styles = this.state.selected || this.state.active || this.state.connectingLineHover ? GRID_CONTENT_CONTAINER_SELECTED_STYLE : GRID_CONTENT_CONTAINER_STYLE;

        roundRect(this.layout.x, this.layout.y, this.layout.width, this.layout.height, this.layout.radius, styles, this.ctx);
    }

    // clears the container
    clearCell() {
        this.state.drawed = false;
        const lineWidth = this.layout.styles.lineWidth || 1;
        this.ctx.clearRect(this.state.x - lineWidth,
            this.state.y - lineWidth,
            this.state.width + (lineWidth * 2),
            this.state.height + (lineWidth * 2));
    }

    // updates the container
    update(layout, state) {
        this.layout = { ...this.layout, ...layout };
        this.state = { ...this.state, ...state };
        super.setPoints(layout);
    }
}
